import styled, { keyframes } from "styled-components";

const shimmer = keyframes`
  0% { background-position: -400px 0; }
  100% { background-position: 400px 0; }
`;

export const TiketDetailsSkeletonStyles = styled.div`
  height: 100%;

  .sk-card {
    display: flex;
    flex-direction: column;
    height: 100%;
    background: ${({ theme }) => theme.colors.semantic.container.white};
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
    border-radius: ${({ theme }) => theme.radius[16]};
    overflow: hidden;
  }

  .sk-header {
    flex: 0 0 auto;
    height: 56px;
    padding: 0 ${({ theme }) => theme.spacing[20]};
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid
      ${({ theme }) => theme.colors.semantic.separator};
  }

  .sk-header__title {
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing[8]};
  }

  .sk-header__close {
    width: 32px;
    height: 32px;
    border-radius: ${({ theme }) => theme.radius.rounded};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border: 1px solid ${({ theme }) => theme.colors.semantic.separator};
    background: ${({ theme }) => theme.colors.semantic.container.white};

    &:hover {
      background: ${({ theme }) => theme.colors.semantic.container.gray};
    }
  }

  .sk-body {
    flex: 1 1 auto;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  .sk-block {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing[16]};
    padding: ${({ theme }) => theme.spacing[20]};
    border-bottom: 1px solid
      ${({ theme }) => theme.colors.semantic.separator};

    &:last-child {
      border-bottom: none;
    }
  }

  .sk-grid-2 {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: ${({ theme }) => theme.spacing[16]};
  }

  .sk-field {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing[8]};
    min-width: 0;
  }

  .sk-col {
    display: flex;
    flex-direction: column;
    gap: 6px;
    flex: 1 1 auto;
  }

  .sk-row-between {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${({ theme }) => theme.spacing[12]};
  }

  .sk-card-row {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing[8]};
    padding: ${({ theme }) => theme.spacing[16]};
    border: 1px solid ${({ theme }) => theme.colors.semantic.separator};
    border-radius: ${({ theme }) => theme.radius[12]};
  }

  .sk-map {
    height: 160px;
    border-radius: ${({ theme }) => theme.radius[12]};
    background: #eef0f3
      linear-gradient(
        90deg,
        rgba(255, 255, 255, 0) 0,
        rgba(255, 255, 255, 0.85) 50%,
        rgba(255, 255, 255, 0) 100%
      );
    background-size: 800px 100%;
    animation: ${shimmer} 1.4s linear infinite;
  }

  .sk-line,
  .sk-pill,
  .sk-btn {
    display: block;
    border-radius: 6px;
    background: #eef0f3
      linear-gradient(
        90deg,
        rgba(255, 255, 255, 0) 0,
        rgba(255, 255, 255, 0.85) 50%,
        rgba(255, 255, 255, 0) 100%
      );
    background-size: 800px 100%;
    animation: ${shimmer} 1.4s linear infinite;
  }

  .sk-line--title {
    height: 18px;
    width: 140px;
  }

  .sk-line--id {
    height: 14px;
    width: 52px;
  }

  .sk-line--branch {
    height: 18px;
    width: 60%;
  }

  .sk-line--address {
    height: 14px;
    width: 80%;
  }

  .sk-line--label {
    height: 10px;
    width: 64px;
  }

  .sk-line--value {
    height: 16px;
    width: 70%;
  }

  .sk-line--meta {
    height: 12px;
    width: 45%;
  }

  .sk-pill {
    height: 22px;
    width: 96px;
    border-radius: 999px;
  }

  .sk-btn {
    height: 32px;
    width: 104px;
    border-radius: 8px;
    flex: 0 0 auto;
  }

  .sk-btn--block {
    width: 100%;
    height: 44px;
  }

  .sk-footer {
    flex: 0 0 auto;
    padding: ${({ theme }) => theme.spacing[16]}
      ${({ theme }) => theme.spacing[20]};
    border-top: 1px solid ${({ theme }) => theme.colors.semantic.separator};
    background: ${({ theme }) => theme.colors.semantic.container.white};
  }
`;
